<template lang="pug">
div
  v-expansion-panels(multiple, v-model="panel")
    v-expansion-panel
      v-expansion-panel-header.text-h6 Your weekly driving range
      v-expansion-panel-content
        v-card-subtitle.mt-4(style="text-align: center") Where do you live?
        AddressFinder(
          :model="bubble.location",
          :clear="true",
          label="Enter an address here"
        )
        v-spacer
        v-card-subtitle.mt-4(style="text-align: center") Roughly, how much driving do you do?
        v-row(justify="center")
          v-col(cols=8, lg=4)
            v-text-field.centered-input(
              v-model="bubble.kms",
              type="number",
              append-outer-icon="mdi-plus-circle-outline",
              @click:append-outer="increment",
              prepend-icon="mdi-minus-circle-outline",
              @click:prepend="decrement",
              min=0,
              onkeyup="if(this.value < 0) this.value = 0;"
            )
        v-row(justify="center", align="center")
          v-col.center(cols=6)
            span.km-indicator {{ bubble.kms }}km per week
            br
            span.petrol-indicator(v-if="bubble.fuelType == 'Petrol'") Or ${{ petrolCost }} per month on petrol
            span.diesel-indicator(v-if="bubble.fuelType == 'Diesel'") Or ${{ dieselCost }} per month on diesel
    v-expansion-panel
      v-expansion-panel-header.text-h6 Add the extra trips you do
      v-expansion-panel-content
        p Tell us about your regular travel needs by adding some trips.<br>This will help us find the right EV to suit your lifestyle.
        TripCard.mt-8(
          v-for="trip in trips",
          v-bind:key="trip.id",
          :trip="trip",
          @remove="removeTrip",
          :expanded="trip.title == 'Give this trip a name'",
          :editTitle="trip.title == 'Give this trip a name'",
          :colour="colourForTrip(trip.id)",
          @tripUpdated="updateBubble",
          @makeReturn="makeReturn"
        )

        v-row(justify="center")
          v-col.center(cols=4)
            v-tooltip(right)
              template(v-slot:activator="{ on }")
                v-btn.primary(v-on:click="addTrip", fab, small, v-on="on") 
                  v-icon mdi-plus
              span Add Trip
    v-row
      v-col.right
        v-btn.ma-4(color="primary", @click="$emit('next')") Next
</template>

<script>
import TripCard from "./TripCard.vue";
import AddressFinder from "./AddressFinder.vue";
export default {
  props: ["trips", "bubble", "settings"],
  components: {
    TripCard,
    AddressFinder,
  },
  data() {
    return {
      panel: [0, 1],
    };
  },
  computed: {
    petrolCost() {
      return this.formatPrice(
        ((this.bubble.kms * 4) / this.settings.petrolConsumption) *
          this.settings.petrolCost
      );
    },
    dieselCost() {
      var kms = this.bubble.kms * 4;
      var price =
        (kms / this.settings.dieselConsumption) * this.settings.dieselCost;
      var RUC = (kms / 1000) * this.settings.RUCperThousand;

      return this.formatPrice(price + RUC);
    },
  },
  methods: {
    updateBubble() {
      if (
        this.bubble.savingsMode == "home" &&
        this.trips.length > 0 &&
        this.trips[0].fromAddress.Address != null &&
        this.trips[0].toAddress.Address != null
      ) {
        this.bubble.savingsMode = "both";
      }
    },
    addTrip() {
      this.trips.push({
        id: this.trips.length + 1,
        title: "Give this trip a name",
        frequency: 5,
        frequencyUnit: "week",
        viaAddresses: [],
        fromAddress: { Address: null },
        toAddress: { Address: null },
        path: [],
      });
    },
    removeTrip(trip) {
      this.trips.splice(
        0,
        this.trips.length,
        ...this.trips.filter((e) => e.id !== trip.id)
      );
      if (this.trips.length == 0) {
        this.bubble.savingsMode = "home";
      }
    },
    makeReturn(trip) {
      let newTrip = JSON.parse(JSON.stringify(trip));
      console.log(trip);
      newTrip.viaAddresses = newTrip.viaAddresses.reverse();
      let from = newTrip.fromAddress;
      newTrip.fromAddress = newTrip.toAddress;
      newTrip.toAddress = from;
      let index = this.trips.findIndex(function (value) {
        return trip.id == value.id;
      });
      newTrip.id = 101 + trip.id;
      this.trips.splice(index + 1, 0, newTrip);
    },
    increment() {
      this.bubble.kms = parseFloat(this.bubble.kms) + 10;
    },
    decrement() {
      this.bubble.kms = Math.max(parseFloat(this.bubble.kms) - 10, 0);
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
}
.centered-input >>> input,
.center {
  text-align: center;
}
</style>